import { Box, Stack, Typography } from '@mui/material';
import { getServiceDurationMinutes, PublicService } from '../types';
import { PublicServiceItem } from './booking/PublicServiceItem';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import type { SupportedCurrency } from '@features/currency/currency.types';

type Props = {
  services: PublicService[];
  preferredCurrency: SupportedCurrency;
  onSelect?: (service: PublicService) => void;
};

const ProfileServices = ({ services, preferredCurrency, onSelect }: Props) => {
  const { t } = useIntlTranslations('profileServices');
  if (services.length === 0) {return null;}

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1.5, color: '#132847' }}>
        {t('services')}
      </Typography>

      <Stack spacing={1}>
        {services.map(service => {
          const durationMin = getServiceDurationMinutes(service.blocks);
          const displayName = service.publicName || service.serviceName;
          const hasDescription = !!service.publicDescription;

          return (
            <PublicServiceItem
              key={service.id}
              service={service}
              isSelected={false}
              durationMin={durationMin}
              displayName={displayName}
              hasDescription={hasDescription}
              onSelect={onSelect}
              preferredCurrency={preferredCurrency}
            />
          );
        })}
      </Stack>
    </Box>
  );
};

export default ProfileServices;
